import { defineNuxtPlugin } from "#app";
import mitt from "mitt";
const emitter = mitt();
export default defineNuxtPlugin((NuxtApp) => {
  let swipe;
  NuxtApp.provide("bus", {
    $on: emitter.on,
    $emit: emitter.emit
  });
  NuxtApp.provide("startSwipe", (e) => {
    swipe = new Swipe(e);
  });
  NuxtApp.provide("handleSwipe", (e) => {
    if (!swipe) {
      return;
    }
    swipe.setEndEvent(e);
    if (swipe.isSwipeRight()) {
      return NuxtApp.$bus.$emit("swipe", "right");
    }
    if (swipe.isSwipeLeft()) {
      return NuxtApp.$bus.$emit("swipe", "left");
    }
    if (swipe.isSwipeDown()) {
      return NuxtApp.$bus.$emit("swipe", "down");
    }
    if (swipe.isSwipeUp()) {
      return NuxtApp.$bus.$emit("swipe", "up");
    }
    swipe = null;
  });
});
const _Swipe = class {
  constructor(startEvent, endEvent) {
    this.startEvent = startEvent;
    this.endEvent = endEvent || null;
  }
  isSwipeLeft() {
    return this.getSwipeDirection() == _Swipe.SWIPE_LEFT;
  }
  isSwipeRight() {
    return this.getSwipeDirection() == _Swipe.SWIPE_RIGHT;
  }
  isSwipeUp() {
    return this.getSwipeDirection() == _Swipe.SWIPE_UP;
  }
  isSwipeDown() {
    return this.getSwipeDirection() == _Swipe.SWIPE_DOWN;
  }
  getSwipeDirection() {
    let start = this.startEvent.changedTouches[0];
    let end = this.endEvent.changedTouches[0];
    if (!start || !end) {
      return null;
    }
    let horizontalDifference = start.screenX - end.screenX;
    let verticalDifference = start.screenY - end.screenY;
    if (Math.abs(horizontalDifference) > Math.abs(verticalDifference)) {
      if (horizontalDifference >= _Swipe.SWIPE_THRESHOLD) {
        return _Swipe.SWIPE_LEFT;
      } else if (horizontalDifference <= -_Swipe.SWIPE_THRESHOLD) {
        return _Swipe.SWIPE_RIGHT;
      }
    } else {
      if (verticalDifference >= _Swipe.SWIPE_THRESHOLD) {
        return _Swipe.SWIPE_UP;
      } else if (verticalDifference <= -_Swipe.SWIPE_THRESHOLD) {
        return _Swipe.SWIPE_DOWN;
      }
    }
    return null;
  }
  setEndEvent(endEvent) {
    this.endEvent = endEvent;
  }
};
let Swipe = _Swipe;
Swipe.SWIPE_THRESHOLD = 50;
Swipe.SWIPE_LEFT = 1;
Swipe.SWIPE_RIGHT = 2;
Swipe.SWIPE_UP = 3;
Swipe.SWIPE_DOWN = 4;
